import { render, staticRenderFns } from "./TermSearch.vue?vue&type=template&id=1db4a63f"
import script from "./TermSearch.vue?vue&type=script&lang=js"
export * from "./TermSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports